<template>
	<svg width="102" height="116" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M87.619 70.78l7.187 4.149c3.51 2.026 2.848 7.29-1.107 8.35l-66.656 17.86c-3.911 1.048-7.116-3.18-5.09-6.69l4.15-7.186-7.064-26.364c-3.944-14.72 3.129-29.802 16.125-36.487l-1.377-5.14a6.814 6.814 0 014.825-8.358 6.814 6.814 0 018.357 4.825l1.377 5.141c14.598-.709 28.264 8.816 32.209 23.536l7.064 26.364zM70.327 94.296a9.046 9.046 0 01-6.401 11.087 9.046 9.046 0 01-11.087-6.4l17.488-4.686z"
			fill="#6C7781"
			opacity=".3"
		/>

		<!-- info/default -->
		<circle v-if="'info' === type" cx="84.645" cy="79.645" r="17.645" fill="white" />
		<circle v-if="'info' === type" cx="84.645" cy="79.6449" r="13.645" fill="#B5BFC9" />
		<path
			v-if="'info' === type"
			d="M84.9413 76.1444C85.8587 76.1444 86.6023 75.4008 86.6023 74.4834C86.6023 73.5661 85.8587 72.8224 84.9413 72.8224C84.0239 72.8224 83.2803 73.5661 83.2803 74.4834C83.2803 75.4008 84.0239 76.1444 84.9413 76.1444Z"
			fill="white"
		/>
		<path
			v-if="'info' === type"
			d="M86.6024 78.9127C86.6024 77.9954 85.8587 77.2517 84.9414 77.2517C84.024 77.2517 83.2803 77.9954 83.2803 78.9127L83.2803 85.5568C83.2803 86.4742 84.024 87.2179 84.9414 87.2179C85.8587 87.2179 86.6024 86.4742 86.6024 85.5568L86.6024 78.9127Z"
			fill="white"
		/>

		<!-- action -->
		<circle v-if="'action' === type" cx="84.645" cy="79.645" r="17.645" fill="white" />
		<path
			v-if="'action' === type"
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M84.6405 66.0001C92.1689 66.0001 98.281 72.1122 98.281 79.6406C98.281 87.169 92.1689 93.2811 84.6405 93.2811C77.1121 93.2811 71 87.169 71 79.6406C71 72.1122 77.1121 66.0001 84.6405 66.0001ZM84.6516 88.0477C84.2 88.0477 83.8057 87.9015 83.4688 87.609C83.1319 87.3166 82.9635 86.9075 82.9635 86.3819C82.9635 85.9228 83.1245 85.5322 83.4466 85.2102C83.7687 84.8881 84.163 84.7271 84.6294 84.7271C85.0958 84.7271 85.4938 84.8881 85.8233 85.2102C86.1527 85.5322 86.3175 85.9228 86.3175 86.3819C86.3175 86.9001 86.1509 87.3073 85.8177 87.6035C85.4845 87.8997 85.0958 88.0477 84.6516 88.0477ZM83.4189 80.7401L83.0635 75.4205C82.9968 74.3839 82.9635 73.6398 82.9635 73.1882C82.9635 72.5736 83.1245 72.0943 83.4466 71.75C83.7687 71.4057 84.1926 71.2335 84.7183 71.2335C85.355 71.2335 85.7807 71.4538 85.9954 71.8944C86.2101 72.3349 86.3175 72.9698 86.3175 73.799C86.3175 74.2876 86.2916 74.7837 86.2397 75.2872L85.7622 80.7623C85.7104 81.4139 85.5993 81.9136 85.429 82.2616C85.2587 82.6096 84.9774 82.7835 84.585 82.7835C84.1852 82.7835 83.9075 82.6151 83.752 82.2782C83.5965 81.9414 83.4855 81.4287 83.4189 80.7401Z"
			fill="#DC3232"
		/>

		<!-- warning -->
		<path
			v-if="'warning' === type"
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M78.9054 61.2626C80.1129 59.2172 82.312 58.0001 84.645 58.0001C86.978 58.0001 89.1771 59.2172 90.3846 61.2626L101.379 79.8878C102.593 81.9442 102.594 84.4902 101.38 86.5468M67.9102 86.5468C66.6965 84.4902 66.6966 81.9444 67.9105 79.888L78.9054 61.2626M101.38 86.5468C100.172 88.5926 97.9729 89.81 95.6398 89.81H73.6502C71.317 89.81 69.1176 88.5925 67.9102 86.5468"
			fill="white"
		/>
		<path
			v-if="'warning' === type"
			d="M84.645 58.0001C82.312 58.0001 80.1129 59.2172 78.9054 61.2626L67.9105 79.888C66.6966 81.9444 66.6965 84.4902 67.9102 86.5468H101.38C102.594 84.4902 102.593 81.9442 101.379 79.8878L90.3846 61.2626C89.1771 59.2172 86.978 58.0001 84.645 58.0001Z"
			fill="white"
		/>
		<path
			v-if="'warning' === type"
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M82.3499 63.2961C82.8234 62.4942 83.6982 62.0001 84.645 62.0001C85.5918 62.0001 86.4667 62.4942 86.9401 63.2961C89.8906 68.2943 94.9841 76.9228 97.9348 81.9213C98.4083 82.7234 98.4084 83.7116 97.935 84.5138C97.4616 85.3159 96.5866 85.81 95.6398 85.81H73.6502C72.7034 85.81 71.8285 85.3159 71.355 84.5138C70.8816 83.7116 70.8817 82.7234 71.3551 81.9213C74.3059 76.9228 79.3994 68.2943 82.3499 63.2961ZM84.6549 82.2494C84.2524 82.2494 83.9009 82.1219 83.6007 81.8669C83.3005 81.6119 83.1503 81.2553 83.1503 80.797C83.1503 80.3968 83.2939 80.0563 83.5809 79.7755C83.868 79.4947 84.2194 79.3543 84.6351 79.3543C85.0508 79.3543 85.4055 79.4947 85.6992 79.7755C85.9929 80.0563 86.1397 80.3968 86.1397 80.797C86.1397 81.2489 85.9912 81.6039 85.6943 81.8621C85.3973 82.1203 85.0508 82.2494 84.6549 82.2494ZM83.5562 75.8784L83.2394 71.2406C83.18 70.3369 83.1503 69.6881 83.1503 69.2944C83.1503 68.7586 83.2939 68.3407 83.5809 68.0406C83.868 67.7404 84.2458 67.5904 84.7143 67.5904C85.2818 67.5904 85.6612 67.7824 85.8526 68.1664C86.044 68.5505 86.1397 69.104 86.1397 69.8269C86.1397 70.253 86.1166 70.6855 86.0704 71.1244L85.6447 75.8978C85.5986 76.4658 85.4996 76.9015 85.3478 77.2048C85.196 77.5083 84.9453 77.66 84.5955 77.66C84.2392 77.66 83.9917 77.5131 83.8531 77.2194C83.7145 76.9257 83.6155 76.4787 83.5562 75.8784Z"
			fill="#F56E28"
		/>

		<!-- success -->
		<circle v-if="'success' === type" cx="84.645" cy="79.645" r="17.645" fill="white" />
		<path
			v-if="'success' === type"
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M84.6452 66C92.1761 66 98.2902 72.1141 98.2902 79.645C98.2902 87.1759 92.1761 93.29 84.6452 93.29C77.1144 93.29 71.0002 87.1759 71.0002 79.645C71.0002 72.1141 77.1144 66 84.6452 66ZM91.8256 76.2927C91.8256 76.0604 91.733 75.8294 91.5656 75.6634L90.3057 74.4035C90.1398 74.2362 89.9075 74.1436 89.6765 74.1436C89.4442 74.1436 89.2132 74.2362 89.0459 74.4035L82.9677 80.4872L80.2446 77.7559C80.0773 77.5885 79.8463 77.4959 79.614 77.4959C79.383 77.4959 79.1507 77.5885 78.9848 77.7559L77.7249 79.0157C77.5575 79.1817 77.4649 79.414 77.4649 79.645C77.4649 79.876 77.5575 80.1083 77.7249 80.2743L82.3384 84.8865C82.5044 85.0538 82.7368 85.1464 82.9677 85.1464C83.2001 85.1464 83.431 85.0538 83.5984 84.8865L91.5656 76.9219C91.733 76.756 91.8256 76.5237 91.8256 76.2927Z"
			fill="#46B450"
		/>
	</svg>
</template>
<script>
export default {
	props: {
		type: {
			type: String,
			default: 'info',
		},
	},
};
</script>
